/**
 * ss-discovery.js
 * Phase 02 — Discovery Experience
 * IntersectionObserver scroll-reveal for .disc-reveal and .disc-reveal-stagger
 * Minimal, production-ready, no dependencies.
 */
(function () {
  'use strict';

  /* Honour reduced-motion preference */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.disc-reveal, .disc-reveal-stagger').forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }

  /* Immediate reveal if no animation wanted */
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -48px 0px' }
  );

  /* Observe all reveal targets */
  document.querySelectorAll('.disc-reveal, .disc-reveal-stagger').forEach(function (el) {
    io.observe(el);
  });

  /* Re-observe after Shopify section re-renders in editor */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.disc-reveal:not(.is-revealed), .disc-reveal-stagger:not(.is-revealed)').forEach(function (el) {
      io.observe(el);
    });
  });
})();
